export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-2">
            <span className="font-heading text-2xl text-primary-400 inline-block mb-4">51吃瓜网</span>
            <p className="text-sm text-secondary-200 leading-relaxed max-w-[400px] mb-4">
              51吃瓜网在线观看是国内领先的娱乐八卦资讯聚合与导航平台，提供51吃瓜官网全网最新入口、51吃瓜网站入口、
              51吃瓜网网址与最新官网地址的持续更新服务。一站导航所有51吃瓜网官方入口，确保你访问正版最新站点，
              畅享全网最热娱乐资讯。
            </p>
            <div className="flex items-center gap-3">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-tiktok-line', 'ri-bilibili-line'].map((icon) => (
                <a
                  key={icon}
                  href="#footer"
                  onClick={(e) => e.preventDefault()}
                  className="w-8 h-8 rounded-lg bg-secondary-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '热门专题', href: '#index' },
                { label: '手机吃瓜', href: '#app' },
                { label: '焦点速递', href: '#carousel' },
                { label: '吃瓜热榜', href: '#ranking' },
                { label: '话题广场', href: '#topics' },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(link.href);
                    if (el) {
                      const top = el.getBoundingClientRect().top + window.scrollY - 80;
                      window.scrollTo({ top, behavior: 'smooth' });
                    }
                  }}
                  className="block text-sm text-secondary-300 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">吃瓜关键词</h4>
            <div className="flex flex-wrap gap-2">
              {['51吃瓜网在线观看', '51吃瓜官网全网最新', '51吃瓜网站入口', '51吃瓜网网址', '51吃瓜最新网址', '51吃瓜官方入口'].map((kw) => (
                <span key={kw} className="text-xs text-secondary-400 bg-secondary-800 px-2 py-1 rounded whitespace-nowrap">{kw}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 pt-6">
          <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
          <div className="flex flex-wrap gap-4 mb-6">
            <span className="text-xs text-secondary-400">更多合作伙伴即将入驻</span>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-400">
            <span>&copy; 2026 51吃瓜网在线观看. All rights reserved.</span>
            <div className="flex items-center gap-4">
              <a href="#hero" onClick={(e) => { e.preventDefault(); const el = document.querySelector('#hero'); if (el) { window.scrollTo({ top: 0, behavior: 'smooth' }); } }} className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">回到顶部</a>
              <span className="whitespace-nowrap">本站仅提供导航服务</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}